import { useAuthStore } from '../stores/authStore.js';

/** Signed-in (non-guest) user id, or undefined for guests / logged out. Read at call time. */
export function accountId(): string | undefined {
  const { user, isGuest, token } = useAuthStore.getState();
  return isGuest || !token ? undefined : user?.id;
}

/** Row visibility: a signed-in user sees only their own rows; guests see only unowned rows. */
export const ownedBy = (row: { ownerId?: string }, uid: string | undefined): boolean =>
  (row.ownerId ?? undefined) === uid;
